// OktErtekeles component translations

export const OKT_ERTEKELES_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.5 Oktatók",
        pageTitle: "12. Oktatók értékelése",
        description: "Kérjük, használja az othv.sze.hu oldalt a kérdések megválaszolásánál.",
        sourceLabel: "Forrás:",
        
        section1: {
            title: "12.1. OTHV oktatói összátlag eredmények",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        section2: {
            title: "12.2. Hallgatói visszajelzések minősítései",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        section3: {
            title: "12.3. Kiemelkedő tantárgyak / jó gyakorlatok",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.5 Teaching Staff",
        pageTitle: "12. Evaluation of Teaching Staff",
        description: "Please use the SETP Results (Student Evaluation of Teaching Performance) report to answer the questions.",
        sourceLabel: "Source:",
        sourceLink: "link",
        
        section1: {
            title: "12.1. SETP Results (Student Evaluation of Teaching Performance)",
            noteLabel: "Comments (optional):",
        },
        
        section2: {
            title: "12.2. Patterns in Student Feedback",
            noteLabel: "Comments (optional):",
        },
        
        section3: {
            title: "12.3. Outstanding Courses / Best Practices",
            noteLabel: "Comments (optional):",
        },
        
        buttons: {
            previous: "Previous section",
            next: "Next section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw finalization"
        },
        
        alerts: {
            requiredFields: "All fields must be filled!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
